module.exports = __webpack_public_path__ + "static/media/2_Breaking down the barriers to connected medication management-72DPI.ef352f0f.png";